FaqTopicpageTemplate = require('../../topicpage.html.mustache')
FAQArticleView = require('./article')
dotdotdot = require('../../../../core/frontend/vendor_modules/jQuery/jquery.dotdotdot')
Backbone = require 'backbone'
Backbone.$ = $

class FAQTopicView extends Backbone.View
  @VIEWID = 1
  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.faq'
    @template = FaqTopicpageTemplate
    @breadCrumbView = @options.breadCrumbView
    @container = @options.container
    @contentModel = @options.contentModel
    @errorContainer = @options.errorContainer

  events :
    "click #topic_explanation"  : "handleTopicReadMoreClicked"

  render : (topicId) ->
    @searchId = topicId
    data = @getTopicHash()
    if @checkTopicId(topicId, data)
      @constructTopicpage(data)
    else
      successCallack = (response) =>
        @constructTopicpage(response)
      errorCb = (data) =>
        @errorCallback(data)
      @contentModel.fetchContent({topicId: topicId, searchId: @searchId, category: "topic"} , successCallack, errorCb)

  checkTopicId : (topicId, data) ->
    if data?.topic?
      return data.topic.id is topicId
    else
      return false

  getTopicHash: () ->
    data = @contentModel.attributes
    if data?.topic?
      return data
    else
      return null

  constructTopicpage : (response) ->
    if response?.topic?
      topicHash =
        searchId : response.topic.searchId
        text : response.topic.text?.replace(/(<([^>]+)>)/ig,"")
      @breadCrumbView.addCrumbs(topicHash)
      @toHtml(response)
    else
      @invalidResponseCallback({searchId : @searchId})

  toHtml : (response) ->
    response.topic.text = response.topic.text.replace(/(<([^>]+)>)/ig,"") if response?.topic?.text?
    hash = $.extend(true, {}, response.topic, window.currentUser, {showVerticalPageFlow: experiments?.showVerticalPageFlow})
    @$el.html toHtml(@template, hash, @I18nScope)
    @breadCrumbView.render()
    @container.html(@el)
    @renderSummarizedArticle(response)

  renderSummarizedArticle : (response) ->
    if response.topic?.articles?.length > 0
      _.each(response.topic.articles, (article)->
        articleView = new FAQArticleView({
          'breadCrumbView' : @breadCrumbView
          'summarized' : true
          'container' : $('#topic_explanation', @el)
        })
        articleView.toHtml({ article : article })
      )

  handleTopicReadMoreClicked : (event) ->
    $target = $(event.target)
    if $target.is("a.article") || $target.is("a.read-more")
      searchId = $target.attr("searchId")
      data = @getTopicHash()
      if searchId? && data?.topic?.articles?
        article = _.find( data.topic.articles, (article)->
          return article.searchId == searchId
        )
        if article?
          @contentModel.set('article', article , {silent: true})

  errorCallback : (data) ->
    Groupon.FAQ.ViewManager.renderErrorHtml({
      container: @errorContainer
      query : data.searchId
      errorHtmlText : "<div data-bhw='faq___#{encodeURIComponent(data.searchId)}___no-results-displayed-for-topics-api-failure' class='noResults'>#{@errorText()}</div>"
    })

  errorText: () ->
    if Groupon.FAQ.ViewManager.isV2View()
      I18n.t('js.modules.faq.refresh_browser')
    else
      I18n.t('js.modules.faq.not_found')

  invalidResponseCallback : (data) ->
    Groupon.FAQ.ViewManager.renderErrorHtml({
      container : @errorContainer
      query : data.searchId
      errorHtmlText : "<div data-bhw='faq___#{encodeURIComponent(data.searchId)}___no-results-displayed-for-topics-api-invalid' class='noResults'>#{I18n.t('js.modules.faq.not_found')}</div>"
    })

module.exports = FAQTopicView
